module.exports = __webpack_public_path__ + "img/classify1-active.131a333.png";